import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { EvaChatbotService } from "../../services/eva-chatbot.service";
import { MsalV3Service } from "../../services/msal-V3.service";

@Component({
  selector: "app-eva-chatbot",
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: "./eva-chatbot.component.html",
  styleUrls: ["./eva-chatbot.component.scss"],
})
export class EvaChatbotComponent
  implements AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild("evaChatbot") chatbotRef!: ElementRef;

  @Input() mode: "chat" | "support" = "support";
  @Input() position: "right" | "left" | "center" = "right";
  @Input() size: "small" | "medium" | "large" = "medium";

  @Output() closed = new EventEmitter<void>();
  @Output() quickAction = new EventEmitter<any>();
  @Output() widgetAction = new EventEmitter<{ action: string; data: any }>();

  private initialized = false;

  constructor(
    private chatbotService: EvaChatbotService,
    private authService: MsalV3Service,
  ) {}

  get userName(): string {
    return this.authService.getUserName();
  }

  get userEmail(): string {
    return this.authService.getUserEmail();
  }

  ngAfterViewInit(): void {
    this.initChatbot();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.initialized &&
      (changes["mode"] || changes["position"] || changes["size"])
    ) {
      this.initChatbot();
    }
  }

  ngOnDestroy(): void {
    // Element cleanup is handled by the web component's disconnectedCallback
  }

  onClose(): void {
    this.closed.emit();
  }

  onQuickAction(event: Event): void {
    this.quickAction.emit((event as CustomEvent).detail);
  }

  onWidgetAction(event: Event): void {
    const detail = (event as CustomEvent).detail;
    this.widgetAction.emit(detail);
  }

  private initChatbot(): void {
    const el = this.chatbotRef?.nativeElement;
    if (!el) return;

    el.config = this.chatbotService.createConfig();
    el.backendAdapter = this.chatbotService.createAdapter();
    this.initialized = true;
  }
}
